<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_maker_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot :title="pageTitle" >
            <div>
            </div>
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-7" style="">
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>

          </div>
          <div class="col-xs-7" style="">
            <div class="row" style="margin-bottom:10px;">
                <button class="btn btn-primary" style="min-width:100px;float: left;margin-left: -10px;" @click="backToList" >＜　戻る</button>
                <button v-if="read_only == false"  class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:5px;background: #92D050;border-color:#92D050;"  @click="onSave" >登録</button>
                <button
                :disabled="showAllocationRequestForm || checkUserPermission(true,permissionMode.ADD) == false"
                v-if="showAllocationRequestBtn && read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;margin-right:5px;" @click="onAllocationRequest"  >割当依頼</button>
                <button
                :disabled="showAllocationRequestForm || checkUserPermission(true,permissionMode.EDIT) == false"
                v-if="read_only == true" class="btn btn-warning" style="min-width:100px;float:right;margin-left: 10px;margin-right:5px;" @click="onEdit"  >編集</button>
                <button v-if="read_only == false" :disabled="false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #A6A6A6;border-color:#A6A6A6;" @click="btnCancel" >キャンセル</button>
                <!-- <button
                :disabled="checkUserPermission(true,permissionMode.DELETE) == false"
                v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">削除</button> -->
            </div>
          </div>
          <div class="col-xs-7" style="">
            <surplus-license-sub-table v-if="showAllocationRequestForm" :create_new="this.subTableSeqID == -1" :ref_id="surplusLicenseSeqID" :seq_id="subTableSeqID" />
          </div>
      </div>
      <confirmation-modal tag="deleteSurplusLicenseModal" @done="onConfirmDelete" />
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_surplus_license';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:surplus_license_details');
import fieldBoxes from '@/components/form-field';

import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import surplusLicenseSubTable from '@/components/sub_pages/surplus_license_sub_page';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'surplus-license-sub-table':surplusLicenseSubTable,
  },
  data() {
    return {
      api_name:"surplus_license",
      page_acl: acl.surplus_license,
      show_allocation_request_form:false,
      sub_table_seq_id:-1
    };
  },
  computed: {
    subTableSeqID:{
      get(){
        return Number(this.sub_table_seq_id) + "";
      },
      set(v){
        this.sub_table_seq_id = v;
      }
    },
    surplusLicenseSeqID(){
      return Number(this.$store.state[this.stateCurrentRow]["seq_id"])
    },
    showAllocationRequestBtn(){
      return this.is_new == false;
    },
    showAllocationRequestForm:{
      get(){
        return this.show_allocation_request_form;
      },
      set(v){
        this.show_allocation_request_form = v;
      }
    },
    pageTitle(){
      return  (this.is_new) ?"余剰ライセンス登録":"余剰ライセンス(詳細)";
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.maker, {}),
          utils.extend(fields.software_name, {}),
          utils.extend(fields.effective_number, {})
        ],
      }
    },
      loadBy(){
      return this.$route.meta.load_by;
    }
  },
  methods: {
    onAllocationRequest(){
      this.showAllocationRequestForm = true;
    },
    onSave(){
      this.read_only = false;
      this.commonSaveInfo(this,this.api_name, {} );
    },
    onEdit(){
      mdebug("onEdit")
      this.commonOnEdit();
    },
    btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete(){
      bus.$emit("deleteSurplusLicenseModal",{
        title: "削除",
        message: "メーカの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    backToList(){
      if(this.loadBy == "review"){
        return this.$router.push({ name: "page_0020_surplus_license_request", params: {} });
      }else{
        return this.$router.push({ name: "page_0020_surplus_license", params: {} });
      }
    }
  },
  mounted() {
    this.commonLoadRecord({},(err,result)=>{
      if(this.loadBy == "review"){
        this.subTableSeqID = this.$route.params.review_seq_id;
        this.showAllocationRequestForm = true;
      }else{
        this.subTableSeqID = -1;
      }
      //this.commonEditDeleteCmdHandler(this);
    })
  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0020_surplus_license_detail.vue?8b75e7ca